export default __webpack_public_path__ + "assets/1dd8ca2765f1f177ab22d9f82d91487b.png";